import { render } from "./RestoUpdate.vue?vue&type=template&id=457f2e00"
import script from "./RestoUpdate.vue?vue&type=script&lang=js"
export * from "./RestoUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__